import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';

class StatusColors {
}
StatusColors.colors = {
    blue: '#2196F3',
    yellow: '#FFD600',
    green: '#4CAF50',
    red: '#D32F2F',
    grey: '#BDBDBD',
    purple: '#6200EA',
    pink: '#C51162',
    darkgrey: '#4A4A4A',
};

const _c0 = function (a0) { return { "xpo-StatusIndicator-tag--darkColor": a0 }; };
function XpoStatusIndicator_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("xpo-StatusIndicator-tag xpo-StatusIndicator-tag--", ctx_r0.predefinedColor, "");
    i0.ɵɵstyleProp("background-color", ctx_r0.customColor);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0, ctx_r0.isDarkColor));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.statusText);
} }
function XpoStatusIndicator_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "lens");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("xpo-StatusIndicator-label-icon xpo-StatusIndicator-label-icon--", ctx_r2.predefinedColor, "");
    i0.ɵɵstyleProp("color", ctx_r2.customColor);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.statusText);
} }
class XpoStatusIndicator {
    get statusColor() {
        return this.statusColorValue;
    }
    set statusColor(value) {
        this.statusColorValue = this.isColorPredefined(value) ? StatusColors.colors[value] : value;
        this.predefinedColor = this.isColorPredefined(value) ? value : null;
        this.customColor = !this.isColorPredefined(value) ? value : null;
    }
    ngOnInit() {
        if (this.isLabel && this.statusColorValue) {
            this.isDarkColor = this.isColorDark(this.statusColorValue);
        }
    }
    isColorPredefined(color) {
        return !!StatusColors.colors[color];
    }
    isColorDark(hexColor) {
        const colorVal = hexColor.substring(1); // strip #
        const rgb = parseInt(colorVal, 16); // convert rrggbb to decimal
        /* eslint-disable */
        const r = (rgb >> 16) & 0xff; // extract red
        const g = (rgb >> 8) & 0xff; // extract green
        const b = (rgb >> 0) & 0xff; // extract blue
        /* eslint-enable */
        const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
        return luma < 160; // this value should be verified with UX
    }
}
XpoStatusIndicator.ɵfac = function XpoStatusIndicator_Factory(t) { return new (t || XpoStatusIndicator)(); };
XpoStatusIndicator.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoStatusIndicator, selectors: [["xpo-status-indicator"]], hostAttrs: [1, "xpo-StatusIndicator"], inputs: { isLabel: "isLabel", statusText: "statusText", statusColor: "statusColor" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["elseBlock", ""], [3, "ngClass"], [1, "xpo-StatusIndicator-label"], [1, "xpo-StatusIndicator-label-text"]], template: function XpoStatusIndicator_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, XpoStatusIndicator_ng_container_0_Template, 3, 9, "ng-container", 0);
        i0.ɵɵtemplate(1, XpoStatusIndicator_ng_template_1_Template, 5, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.isLabel)("ngIfElse", _r1);
    } }, directives: [i1.NgIf, i1.NgClass, i2.MatIcon], styles: [".flex--stretch{flex:1}.xpo-StatusIndicator{border-radius:1px;display:inline-flex}.xpo-StatusIndicator-label{align-items:center;display:flex}.xpo-StatusIndicator-label-text{color:#212121;font-size:14px;height:20px;line-height:20px}.xpo-StatusIndicator-label-icon.mat-icon{font-size:12px;height:12px;margin-right:8px;width:12px}.xpo-StatusIndicator-label-icon--blue{color:#2196f3}.xpo-StatusIndicator-label-icon--yellow{color:#ffd600}.xpo-StatusIndicator-label-icon--green{color:#4caf50}.xpo-StatusIndicator-label-icon--red{color:#d32f2f}.xpo-StatusIndicator-label-icon--grey{color:#bdbdbd}.xpo-StatusIndicator-label-icon--purple{color:#6200ea}.xpo-StatusIndicator-label-icon--pink{color:#c51162}.xpo-StatusIndicator-label-icon--darkgrey{color:#4a4a4a}.xpo-StatusIndicator-tag{border-radius:2px;box-sizing:border-box;color:#4a4a4a;display:inline-flex;font-size:10px;font-style:normal;font-weight:700;height:16px;line-height:12px;padding:2px 4px;text-align:center;text-transform:uppercase}.xpo-StatusIndicator-tag--blue{background:#2196f3}.xpo-StatusIndicator-tag--yellow{background:#ffd600}.xpo-StatusIndicator-tag--green{background:#4caf50}.xpo-StatusIndicator-tag--red{background:#d32f2f}.xpo-StatusIndicator-tag--grey{background:#bdbdbd}.xpo-StatusIndicator-tag--purple{background:#6200ea}.xpo-StatusIndicator-tag--pink{background:#c51162}.xpo-StatusIndicator-tag--darkgrey{background:#4a4a4a}.xpo-StatusIndicator-tag--darkColor{color:#fff}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoStatusIndicator, [{
        type: Component,
        args: [{
                selector: 'xpo-status-indicator',
                templateUrl: './status-indicator.component.html',
                styleUrls: ['./status-indicator.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    class: 'xpo-StatusIndicator',
                },
            }]
    }], null, { isLabel: [{
            type: Input
        }], statusText: [{
            type: Input
        }], statusColor: [{
            type: Input
        }] }); })();

class XpoStatusIndicatorModule {
}
XpoStatusIndicatorModule.ɵfac = function XpoStatusIndicatorModule_Factory(t) { return new (t || XpoStatusIndicatorModule)(); };
XpoStatusIndicatorModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoStatusIndicatorModule });
XpoStatusIndicatorModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, MatIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoStatusIndicatorModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoStatusIndicator],
                imports: [CommonModule, MatIconModule],
                exports: [XpoStatusIndicator],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoStatusIndicatorModule, { declarations: [XpoStatusIndicator], imports: [CommonModule, MatIconModule], exports: [XpoStatusIndicator] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { StatusColors, XpoStatusIndicator, XpoStatusIndicatorModule };
